import HomeView from '@/views/HomeView.vue'
import Sidebar from '@/components/nav/NavComonents.vue'

export default [
    {
        path: '/order',
        name: '订单管理',
        meta: {
            title: "订单管理",
        },
        redirect: '/order/petCaregiver',
        leaf: false, //是否为单节点，增加属性
        menuShow: true,
        component: HomeView,
        icoClass: 'el-icon-user',
        children: [
            {
                path: '/order/petCaregiver',
                name: "宠托师订单",
                meta: {
                    title: "宠托师订单",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/order/petCaregiver/index.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/order/petNurseCaregiver',
                name: "洗护师订单",
                meta: {
                    title: "洗护师订单",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/order/petNurseCaregiver/index.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/order/orderDetail',
                name: "订单详情",
                meta: {
                    title: "订单详情",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: false,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/order/components/caregiverOrderModel/orderDetail.vue'),
                    sidebar: Sidebar
                }
            },
        ]
    }
]